<!--
 * @Author: xsong
 * @Date: 2021-11-03 13:40:13
 * @LastEditTime: 2021-11-03 18:01:52
 * @LastEditors: xsong
 * @Description: 
 * @FilePath: /acey-web/src/components/dialog.vue
-->
<template>
  <div class="acey-dialog">
    <el-dialog :visible.sync="visible" width="540px" custom-class="dialog">
      <template v-slot:title>
        <div class="title">
          <div class="English-title">Service&amp;ability</div>
          <div class="modal-name">合作咨询</div>
        </div>
      </template>
      <el-form :model="form" label-position="left" label-width="100px" :rules="rules" ref="form" size="medium">
        <el-form-item label="客户联系人" prop="name">
          <el-input v-model="form.name" autocomplete="off" class="input"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" autocomplete="off" class="input" type="number"></el-input>
        </el-form-item>
        <el-form-item label="意向类型" prop="region">
          <el-select v-model="form.region" placeholder="请选择活动区域" class="input">
            <el-option label="APP开发" value="APP开发"></el-option>
            <el-option label="小程序开发" value="小程序开发"></el-option>
            <el-option label="行业解决方案" value="行业解决方案"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向描述" prop="desc">
          <el-input type="textarea" :autosize="{ minRows: 3 }" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="commit">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        form: {
          name: '',
          phone: '',
          region: '',
          delivery: false,
          desc: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
          phone: [{ required: true, trigger: 'blur', message: '请输入联系电话' }],
          region: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入选择您的意向类型',
            },
          ],
          desc: [{ required: true, trigger: 'blur', message: '请输入您的意向类型' }],
        },
      }
    },
    methods: {
      close() {
        this.visible = false
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
      },
      show() {
        this.visible = true
      },
      commit() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            this.$message({ showClose: true, message: '提交成功', type: 'success' })
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  //@import '@/styles/variables.scss';
  .acey-dialog {
  }
</style>
